import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import ImageIcon from "@mui/icons-material/Image";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import VideoCameraBackIcon from "@mui/icons-material/VideoCameraBack";
import CommunicateContext from "../../store/CommunicateContext";
import { CircularProgress } from "@mui/material";
import { getMeApi } from "../utils/components/MeApi";
import { useTheme } from "../../contexts/ThemeContext";
import { X } from "lucide-react";

Modal.setAppElement("#root");

const SelectTemplateModal = (props) => {
  const { darkMode } = useTheme();
  const communicateCtx = useContext(CommunicateContext);
  const { openModal, closeModal } = props;
  const [templateIndex, setTemplateIndex] = useState("null");
  const [bodyT, setBodyT] = useState("");
  const [footerT, setFooterT] = useState("");
  const [headerVariable, setHeaderVariable] = useState("");
  // const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [variables, setVariables] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [webButtonVariableValue, setWebButtonVariableValue] = useState();
  const [meData, setMeData] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Filter templates based on search term (case-insensitive)
  const filteredTemplates =
    props.templates?.filter((template) =>
      template.name.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

  // Customize styles based on theme
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "70%",
      height: "70vh",
      position: "relative",
      padding: "0px 0px",
      backgroundColor: darkMode ? "#121212" : "#fafafa",
      color: darkMode ? "#fafafa" : "#121212",
      border: `1px solid ${darkMode ? "#2f2f2f" : "#c4c4c4"}`,
    },
    overlay: {
      backgroundColor: "rgba(1,1,1,0.4)",
      backdropFilter: "blur(4px)",
      zIndex: 10000,
    },
    dropdown: {
      border: `1px solid ${darkMode ? "#2f2f2f" : "#c4c4c4"}`,
      padding: "8px 12px",
      borderRadius: "7px",
      backgroundColor: darkMode ? "#121212" : "#fafafa",
      color: darkMode ? "#fafafa" : "#121212",
      width: "100%",
      minWidth: "200px",
      outline: "none",
      fontSize: "14px",
    },
    inputRow: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      marginBottom: "16px",
    },
    label: {
      minWidth: "60px",
      fontWeight: "500",
      fontSize: "14px",
    },
    selectDropdown: {
      border: `1px solid ${darkMode ? "#0369a1" : "#0284c7"}`,
      backgroundColor: darkMode ? "#0369a1" : "#0284c7",
      color: "#ffffff",
      padding: "6px 12px",
      borderRadius: "4px",
      fontSize: "13px",
      fontWeight: "600",
      outline: "none",
      cursor: "pointer",
      minWidth: "180px",
    },
  };

  let subtitle = {
    style: {},
  };
  let headerUrl = "";

  function afterOpenModal() {
    subtitle.style.color = "#f00";
  }

  // Handle input selection on focus
  const handleInputFocus = (e) => {
    e.target.select();
  };

  function onTemplateSelect(template) {
    setHeaderVariable("");
    setIsDropdownOpen(false);
    setSearchTerm("");

    if (template) {
      props.setSelectedTemplate(template);
      props.setTemplateName(template.name);
      let varData = [];
      let body = "";
      let footer = "";
      for (let i = 0; i < template.components.length; i++) {
        if (template.components[i].type === "BODY") {
          body = template.components[i].text;
        }
        if (template.components[i].type === "FOOTER") {
          footer = template.components[i].text;
        }
      }
      setBodyT(body);
      setFooterT(footer);
      for (let i = 1; i <= template.variableCount; i++) {
        varData.push("");
      }
      setVariables(varData);
      setTemplateIndex(template.name);
    } else {
      setBodyT("");
      setFooterT("");
      props.setSelectedTemplate(null);
      setTemplateIndex("null");
    }
  }

  async function onSend() {
    setIsLoading(true);
    if (
      props.selectedTemplate.headerMediaType != "TEXT" &&
      props.selectedTemplate.headerMediaType != "" &&
      selectedFile != null
    ) {
      await uploadFile();
    }
    let reqBody = {
      action: "SendMessageToCustomer",
      data: {
        userid: props.userid,
        accountid: props.appAccountId,
        appAccountId: props.appAccountId,
        objectid: communicateCtx.objectid,
        templateId: props.selectedTemplate.templateId,
        variables: variables,
        headerMediaType: props.selectedTemplate.headerMediaType,
        headerMediaURL: headerUrl,
        headerText: headerVariable,
        isPortal: true,
        webVariableValue: webButtonVariableValue,
      },
    };

    props.ws.send(JSON.stringify(reqBody));
    setIsLoading(false);
    closeModal();
    setHeaderVariable("");
  }

  function changeVariableValue(e, varNo) {
    let temp = [...variables];
    temp[varNo] = e.target.value;
    setVariables(temp);
  }

  const getMeApiData = async () => {
    const response = await getMeApi();
    if (response?.data?.message) {
      setMeData(response.data.message);
    }
  };

  useEffect(() => {
    getMeApiData();
  }, []);

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file || selectedFile);
    try {
      setIsLoading(true);
      const response = await axios({
        method: "post",
        url: `https://api-test.phloz.app/chatapp/uploadFile?accountId=${
          meData.account?.id || props.accountid
        }&userId=${props.userid}&objectid=${communicateCtx.objectid}`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      headerUrl = response.data.data.fileUrl;
      props.setSelectedMedia(response.data.data.fileUrl);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileSelect = (event) => {
    setSelectedFile(event.target.files[0]);
    uploadFile(event.target.files[0]);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleDropdownBlur = (e) => {
    // Close dropdown when clicking outside
    setTimeout(() => {
      setIsDropdownOpen(false);
    }, 200);
  };

  return (
    <div>
      <Modal
        isOpen={openModal}
        onAfterOpen={afterOpenModal}
        onRequestClose={(v) => closeModal(false)}
        style={customStyles}
        contentLabel="Example Modal"
        className={darkMode ? "dark" : ""}
      >
        <div
          className="flex w-full justify-between items-center h-[10%] px-[16px]"
          style={{
            borderBottom: `1px solid ${darkMode ? "#2f2f2f" : "#c4c4c4"}`,
            backgroundColor: darkMode ? "#121212" : "#fafafa",
            color: darkMode ? "#fafafa" : "#121212",
          }}
        >
          <div className="font-bold">
            Send Template Message to Contact{" "}
            {props.profile != null ? props.profile.Data.object.phone : null}
          </div>
          <div
            className="cursor-pointer p-1 hover:bg-opacity-10 hover:bg-gray-500 rounded-full"
            onClick={(v) => closeModal(false)}
          >
            <X size={20} color={darkMode ? "#fafafa" : "#121212"} />
          </div>
        </div>

        <div
          className="flex w-full justify-between items-center relative h-[80%] px-[16px] py-[16px] gap-8"
          style={{
            backgroundColor: darkMode ? "#121212" : "#fafafa",
            color: darkMode ? "#fafafa" : "#121212",
          }}
        >
          <div
            className="circle_cont"
            style={{
              display: isLoading ? "flex" : "none",
            }}
          >
            <svg
              className="svg"
              viewBox="0 0 100 100"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="50"
                cy="50"
                r="30"
                fill="transparent"
                stroke={darkMode ? "#fafafa" : "#121212"}
                strokeWidth="8px"
                strokeDasharray="160"
              />
            </svg>
          </div>
          <div className="self-start" style={{ width: "60%" }}>
            <div className="font-semibold py-[10px]">Select Template</div>

            {/* Custom Searchable Dropdown */}
            <div className="relative my-[16px]">
              <div
                className="cursor-pointer"
                onClick={handleDropdownToggle}
                style={{
                  ...customStyles.dropdown,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  minHeight: "32px",
                  padding: "8px 12px",
                }}
              >
                <span style={{ flex: 1, textAlign: "left" }}>
                  {templateIndex === "null" ? "Select Template" : templateIndex}
                </span>
                <span style={{ fontSize: "12px", marginLeft: "8px" }}>
                  {isDropdownOpen ? "▲" : "▼"}
                </span>
              </div>

              {isDropdownOpen && (
                <div
                  className="absolute w-full"
                  style={{
                    top: "100%",
                    left: 0,
                    zIndex: 1000,
                    backgroundColor: darkMode ? "#121212" : "#fafafa",
                    border: `1px solid ${darkMode ? "#2f2f2f" : "#c4c4c4"}`,
                    borderRadius: "7px",
                    maxHeight: "200px",
                    overflowY: "auto",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    marginTop: "2px",
                  }}
                >
                  {/* Search input inside dropdown */}
                  <div
                    style={{
                      padding: "8px",
                      borderBottom: `1px solid ${
                        darkMode ? "#2f2f2f" : "#c4c4c4"
                      }`,
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Search templates..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                      onFocus={handleInputFocus}
                      style={{
                        width: "100%",
                        padding: "4px 8px",
                        border: `1px solid ${darkMode ? "#2f2f2f" : "#c4c4c4"}`,
                        borderRadius: "4px",
                        backgroundColor: darkMode ? "#121212" : "#fafafa",
                        color: darkMode ? "#fafafa" : "#121212",
                        outline: "none",
                        fontSize: "14px",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>

                  {/* Options */}
                  <div>
                    <div
                      className="cursor-pointer px-3 py-2"
                      onClick={() => onTemplateSelect(null)}
                      style={{
                        color: darkMode ? "#fafafa" : "#121212",
                        fontSize: "14px",
                        borderBottom: `1px solid ${
                          darkMode ? "#2f2f2f" : "#e0e0e0"
                        }`,
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = darkMode
                          ? "rgba(255, 255, 255, 0.1)"
                          : "rgba(0, 0, 0, 0.05)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "transparent";
                      }}
                    >
                      Select Template
                    </div>
                    {filteredTemplates.map((template, index) => (
                      <div
                        key={index}
                        className="cursor-pointer px-3 py-2"
                        onClick={() => onTemplateSelect(template)}
                        style={{
                          color: darkMode ? "#fafafa" : "#121212",
                          fontSize: "14px",
                          borderBottom:
                            index < filteredTemplates.length - 1
                              ? `1px solid ${darkMode ? "#2f2f2f" : "#e0e0e0"}`
                              : "none",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = darkMode
                            ? "rgba(255, 255, 255, 0.1)"
                            : "rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "transparent";
                        }}
                      >
                        {template.name}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div
              className="temp-variables"
              style={{
                display:
                  templateIndex !== "null" && props.selectedTemplate
                    ? "block"
                    : "none",
              }}
            >
              {variables.map((variable, index) => (
                <div style={customStyles.inputRow} key={index}>
                  <label style={customStyles.label}>Var {index + 1}</label>
                  <input
                    placeholder="custom variable"
                    type="text"
                    value={variables[index]}
                    onChange={(e) => {
                      changeVariableValue(e, index);
                    }}
                    onFocus={handleInputFocus}
                    style={{
                      ...customStyles.dropdown,
                      flex: 1,
                      maxWidth: "200px",
                    }}
                  />
                  <span
                    style={{
                      fontSize: "14px",
                      color: darkMode ? "#fafafa" : "#121212",
                    }}
                  >
                    or
                  </span>
                  <select
                    onChange={(e) => changeVariableValue(e, index)}
                    style={customStyles.selectDropdown}
                  >
                    <option value="--">Choose Pre-defined values</option>
                    {props.contactFormData.map((e, idx) =>
                      e.fields.map((label, labelIdx) => (
                        <option
                          key={`${idx}-${labelIdx}`}
                          value={label.internalName}
                        >
                          {label.label}
                        </option>
                      ))
                    )}
                  </select>
                </div>
              ))}
              <div>
                {props.selectedTemplate &&
                  props.selectedTemplate.webButtonVariableCount === 1 && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        marginTop: "16px",
                        marginBottom: "16px",
                      }}
                    >
                      <label
                        style={{
                          ...customStyles.label,
                          minWidth: "100px",
                        }}
                      >
                        Web Button:
                      </label>
                      <input
                        type="text"
                        name="webButtonVarible"
                        style={{
                          ...customStyles.dropdown,
                          flex: 1,
                          maxWidth: "300px",
                        }}
                        onChange={(e) =>
                          setWebButtonVariableValue(e.target.value)
                        }
                        onFocus={handleInputFocus}
                      />
                    </div>
                  )}
              </div>
              <div
                style={{
                  display:
                    props.selectedTemplate &&
                    props.selectedTemplate.headerMediaType !== "TEXT" &&
                    props.selectedTemplate.headerMediaType !== ""
                      ? "block"
                      : "none",
                }}
              >
                <div className="font-semibold py-[10px]">
                  Select Header{" "}
                  {props.selectedTemplate &&
                  props.selectedTemplate.headerMediaType === "IMAGE"
                    ? "Image"
                    : props.selectedTemplate &&
                      props.selectedTemplate.headerMediaType === "VIDEO"
                    ? "Video"
                    : "File"}
                </div>
                <input
                  type="file"
                  onChange={handleFileSelect}
                  accept={
                    props.selectedTemplate &&
                    props.selectedTemplate.headerMediaType === "IMAGE"
                      ? "image/*"
                      : props.selectedTemplate &&
                        props.selectedTemplate.headerMediaType === "VIDEO"
                      ? "video/*"
                      : ""
                  }
                  style={{
                    color: darkMode ? "#fafafa" : "#121212",
                  }}
                />
              </div>
              {isLoading && (
                <div className="w-full mx-auto flex justify-center">
                  <CircularProgress
                    style={{ color: darkMode ? "#fafafa" : "#121212" }}
                  />
                </div>
              )}

              <div
                style={{
                  display:
                    props.selectedTemplate &&
                    props.selectedTemplate.headerVariable === true
                      ? "block"
                      : "none",
                }}
              >
                <div className="font-semibold py-[10px]">Header Variable</div>
                <input
                  type="text"
                  value={headerVariable}
                  style={customStyles.dropdown}
                  onChange={(e) => {
                    setHeaderVariable(e.target.value);
                  }}
                  onFocus={handleInputFocus}
                />
              </div>
            </div>
          </div>
          <div className="preview-template w-2/5">
            <div className="bgImg">
              <div
                className="chat-bubbles"
                style={{
                  backgroundColor: darkMode ? "#1e1e1e" : "#f0f0f0",
                  color: darkMode ? "#fafafa" : "#121212",
                  border: `1px solid ${darkMode ? "#2f2f2f" : "#c4c4c4"}`,
                  padding: "12px",
                  borderRadius: "8px",
                }}
              >
                {props.selectedTemplate &&
                props.selectedTemplate.headerMediaType === "IMAGE" ? (
                  <div className="sample-image">
                    <ImageIcon
                      style={{ color: darkMode ? "#fafafa" : "#121212" }}
                    ></ImageIcon>
                  </div>
                ) : null}
                {props.selectedTemplate &&
                props.selectedTemplate.headerMediaType === "DOCUMENT" ? (
                  <div className="sample-file">
                    <InsertDriveFileIcon
                      style={{ color: darkMode ? "#fafafa" : "#121212" }}
                    ></InsertDriveFileIcon>
                  </div>
                ) : null}
                {props.selectedTemplate &&
                props.selectedTemplate.headerMediaType === "VIDEO" ? (
                  <div className="sample-file">
                    <VideoCameraBackIcon
                      style={{ color: darkMode ? "#fafafa" : "#121212" }}
                    ></VideoCameraBackIcon>
                  </div>
                ) : null}

                <div className="mb-[10px]">{bodyT}</div>
                <div className="text-gray-400">{footerT}</div>
                <div className="bubble-arrow"></div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="flex w-full justify-end items-center h-[10%] px-[16px]"
          style={{
            borderTop: `1px solid ${darkMode ? "#2f2f2f" : "#c4c4c4"}`,
            backgroundColor: darkMode ? "#121212" : "#fafafa",
          }}
        >
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mx-4 rounded"
            onClick={() => {
              closeModal(true);
            }}
          >
            {props.isEdit ? "Update" : "Add"}
          </button>
          <button
            className={`${
              darkMode
                ? "bg-gray-800 text-gray-200 border-gray-600"
                : "bg-white text-gray-800 border-gray-400"
            } hover:bg-opacity-90 font-semibold py-2 px-4 border rounded shadow`}
            onClick={(v) => closeModal(false)}
          >
            Close
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default SelectTemplateModal;
